<template>
  <the-mask
    class="form-control"
    :mask="mask"
    v-model="value"
    :name="name"
    type="text"
    :masked="true"
    :class="getClass"
    :placeholder="placeholder"
    :inputmode="inputmode"
  ></the-mask>
</template>

<script>
import { TheMask } from "vue-the-mask";

export default {
  name: "MaskedInput",
  components: {
    TheMask,
  },
  props: {
    placeholder: { type: String },
    mask: { type: String },
    value: { type: String },
    name: { type: String },
    state: { type: Boolean },
    optional: { type: Boolean },
    inputmode: { type: String }
  },
  watch: {
    value: function (val) {
      this.$emit("input", val);
    },
  },
  computed: {
    getClass: function () {
      if (this.optional || this.state === null || this.state === undefined || this.state === "") {
        return '';
      }

      if (this.state) {
        return "is-valid";
      } else {
        return "is-invalid";
      }
    },
  },
};
</script>

<style scoped></style>
